import {Component, OnDestroy, OnInit, ViewChild, Output, Input, EventEmitter} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {StringUtils} from "../services/string-utils";
import {flatMap, map, tap} from 'rxjs/operators';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-roaming-partners',
  templateUrl:'./roaming-partners.component.html',
})
export class RoamingPartnersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  listInfo: Object;

  listRoamingPartners: any[];
  canAddRoamingPartners: boolean;

  public createRP = true;
  public inputKeywordRoamingPartnerSearch = "";
  public optionRoamingPartnerSearch = "Search Type";

  public roamingPartnersRefreshing = false;

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  configPagerRoamingPartners: PaginationInstance = {
    id: 'roaming-partners-list',
    currentPage: 1,
    itemsPerPage: 5,
  };

  @Input() virtId: string;
  @Input() netIds: string[];
  @Input() name: string;
  @Input() renderNsGroup: boolean;
  @Output() roamingPartnersLoadedEvent = new EventEmitter<any[]>();

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private userVerificationService: UserVerificationService,
    private httpService: HttpService) {

    this.isAdmin = this.userVerificationService.isAdmin;
  }

  editRoamingPartners(netAid, netBid, name, partnerName, id, partnerId) {
    this.router.navigate(['./edit-roaming-partners'], {
      queryParams: {
        netAid,
        netBid,
        name,
        partnerName,
        id,
        partnerId
      }
    });
  }

  createRoamingPartnersPage(name, id, virtId, title) {
    this.router.navigate(['./create-roaming-partners'], {queryParams: {name, id, virtId, title}});
  }

  getAllNetworkServerWithoutRoamingRelationship(virtId){
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVERS_WOR;
    var body = {
      "virtID" : virtId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          this.canAddRoamingPartners = data.length != 0;
        }
      );
  }

  //get Roaming Partners widget
  RoamingPartners(id) {
    var body: any = {"virtId": id};
    var url = ApiEndpoints.GET_ROAMING_PARTNERS;
    this.roamingPartnersRefreshing = true;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listRoamingPartners = this.parseRoamingPartnersList(data);
          this.roamingPartnersLoadedEvent.emit(this.listRoamingPartners);
          this.roamingPartnersRefreshing = false;
        }
      );
  }

  //Roaming Partners search func
  RoamingSearch(vIdSearch, urlSearch, filterSearch, keywordSearch) {
    if (filterSearch == "Name") {
      var body: any = {"virtId": vIdSearch, "name": keywordSearch};
      var url = urlSearch;
      this.roamingPartnersRefreshing = true;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      });
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listRoamingPartners = this.parseRoamingPartnersList(data);
            this.roamingPartnersLoadedEvent.emit(this.listRoamingPartners);
            this.roamingPartnersRefreshing = false;
          }
        );
    }
    if (filterSearch == "NetID") {
      var body: any = {"virtId": vIdSearch, "netId": keywordSearch};
      var url = urlSearch;
      this.roamingPartnersRefreshing = true;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      });
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listRoamingPartners = this.parseRoamingPartnersList(data);
            this.roamingPartnersLoadedEvent.emit(this.listRoamingPartners);
            this.roamingPartnersRefreshing = false;
          }
        );
    }
    if (filterSearch == 'Search Type') {
      this.RoamingPartners(this.virtId)
    }
  }

  refreshRoamingPartners() {
    var urlSearch = ApiEndpoints.GET_ROAMING_PARTNERS;
    this.RoamingSearch(this.virtId, urlSearch, this.optionRoamingPartnerSearch, this.inputKeywordRoamingPartnerSearch);
  }

  onKeywordSearch(event: KeyboardEvent) {
    var urlSearch = ApiEndpoints.GET_ROAMING_PARTNERS;
    if (event.keyCode === 13) {
      this.RoamingSearch(this.virtId, urlSearch, this.optionRoamingPartnerSearch, this.inputKeywordRoamingPartnerSearch);
    }
  }

  onOptionRoamingPartnerSearchChanged(event) {
    const value = event.target.value;
    this.inputKeywordRoamingPartnerSearch = "";
  }

  parseRoamingPartnersList(listRoamingPartners) {
    listRoamingPartners.forEach(partner => {
      if (partner.sUL || partner.fUL) {
        partner.sUL = partner.sUL ? partner.sUL : 0;
        partner.fUL = partner.fUL ? partner.fUL : 0;
        partner.balUL = partner.fUL - partner.sUL;
      } else {
        partner.balUL = 0;
      }

      if (partner.sDL || partner.fDL) {
        partner.sDL = partner.sDL ? partner.sDL : 0;
        partner.fDL = partner.fDL ? partner.fDL : 0;
        partner.balDL = partner.fDL - partner.sDL;
      } else {
        partner.balDL = 0;
      }

      if (partner.policyType == 'Balanced Peering') {
        partner.policyType = 'Balanced';
      }

      if (partner.policyType == 'Unrestricted Peering') {
        partner.policyType = 'Unrestricted';
        partner.snsULTh = '';
        partner.snsDLTh = '';
        partner.fnsULTh = '';
        partner.fnsDLTh = '';
      }
      partner.netIds = this.insertSpacesBetweenIds(partner.netIds);
    });
    return listRoamingPartners;
  }

  sendRoamingParteners(i) {
    this.userVerificationService.roamingPartner.next(this.listRoamingPartners[i])
  }

  insertSpacesBetweenIds(ids: Array<string>) {
    return StringUtils.insertSpacesBetweenIds(ids);
  }

  resetPager() {
    this.configPagerRoamingPartners.currentPage = 1;
  }

  ngOnInit() {
    this.RoamingPartners(this.virtId);
    this.getAllNetworkServerWithoutRoamingRelationship(this.virtId)

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1
    });
  }

  ngOnDestroy() {

  }

}
